import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionsStorageService {
  set permissions(roles: string[]) {
    localStorage.setItem('permissions', JSON.stringify(roles));
  }

  get permissions(): string[] {
    const permissions = localStorage.getItem('permissions');
    if (!permissions) {
      return [];
    }

    return JSON.parse(permissions);
  }
}
